import {
  JOIN_USER_SEARCH, JOIN_USER_SEARCH_FAILURE, JOIN_USER_SEARCH_SUCCESS,
  PROPOSE_IMAGE_UPLOAD, PROPOSE_IMAGE_UPLOAD_FAILURE, PROPOSE_IMAGE_UPLOAD_SUCCESS,
  PROPOSE_CREATE, PROPOSE_CREATE_FAILURE, PROPOSE_CREATE_SUCCESS

} from './mutation-types'

export default {
  state: {
    joinUsers: null,
    uploadError: false
  },
  getters: {
    joinUsers: state => {
      return state.joinUsers
    },
    proposeUploadError: state => {
      return state.uploadError
    }
  },
  actions: {
    [JOIN_USER_SEARCH] ({dispatch, state, commit}, params) {
      var url = '/asovi/proposes/join_user_search'
      var data = params.data
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(JOIN_USER_SEARCH_FAILURE, res.data)
          } else {
            commit(JOIN_USER_SEARCH_SUCCESS, {
              data: res.data,
              callback: params.callback
            })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROPOSE_IMAGE_UPLOAD] ({dispatch, state, commit}, params) {
      state.uploadSuccess = false
      state.uploadError = false

      dispatch('apiPatch', { url: '/asovi/proposes/propose_image', data: params.data, loadparams: false })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_IMAGE_UPLOAD_FAILURE, res.data)
          } else {
            commit(PROPOSE_IMAGE_UPLOAD_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        state.uploadError = true
        params.errorCallback()
        throw error
      })
    },
    [PROPOSE_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/asovi/proposes', data: data, noneedloading: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_CREATE_FAILURE, res.data)
          } else {
            commit(PROPOSE_CREATE_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [JOIN_USER_SEARCH_FAILURE] (state, data) {
      console.log('JOIN_USER_SEARCH_FAILURE')
    },
    [JOIN_USER_SEARCH_SUCCESS] (state, data) {
      console.log('JOIN_USER_SEARCH_SUCCESS')
      state.joinUsers = data.data.data
      if (data.callback) {
        data.callback()
      }
    },
    [PROPOSE_IMAGE_UPLOAD_FAILURE] (state, data) {
      console.log('PROPOSE_IMAGE_UPLOAD_FAILURE')
      state.uploadError = true
    },
    [PROPOSE_IMAGE_UPLOAD_SUCCESS] (state, data) {
      console.log('PROPOSE_IMAGE_UPLOAD_SUCCESS')
      state.uploadSuccess = true
      data.callback(data.data)
    },
    [PROPOSE_CREATE_FAILURE] (state, data) {
      console.log('PROPOSE_CREATE_FAILURE')
    },
    [PROPOSE_CREATE_SUCCESS] (state, data) {
      console.log('PROPOSE_CREATE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/propose-new.js